import React, { useEffect, useState } from 'react'
import { useParams, Navigate } from 'react-router-dom'
import SEO from '../components/SEO'
import NotFoundPage from './NotFoundPage'

export default function LegacyRedirectPage() {
  const { caseNumber } = useParams()
  const [redirectTarget, setRedirectTarget] = useState(null)
  const [loading, setLoading] = useState(true)

  // Check if caseNumber is numeric (e.g. 13637, 12768, etc.)
  const isNumeric = /^\d+$/.test(caseNumber || '')

  useEffect(() => {
    if (!isNumeric) {
      setLoading(false)
      return
    }

    setLoading(true)
    fetch('https://api.dev.auxo.dk/public/v2/content/baade?limit=100')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.items) {
          const found = data.items.find(
            (b) => String(b.sagsnummer || '').trim() === String(caseNumber).trim()
          )
          if (found) {
            const boatSlug =
              (found.url_slug || '').trim() ||
              (typeof found.slug === 'object' ? found.slug._ : found.slug) ||
              found.id
            setRedirectTarget(`/baad/${boatSlug}`)
          } else {
            setRedirectTarget('/baade')
          }
        } else {
          setRedirectTarget('/baade')
        }
        setLoading(false)
      })
      .catch(() => {
        setRedirectTarget('/baade')
        setLoading(false)
      })
  }, [caseNumber, isNumeric])

  if (!isNumeric) {
    return <NotFoundPage />
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 py-20">
        <SEO title="Omdirigerer båd... - Nordfyn Marine" />
        <div className="text-center space-y-3">
          <i className="fa-solid fa-spinner animate-spin text-4xl text-[#1E7BC1]" />
          <p className="text-xs text-slate-600 font-medium">Søger efter sagsnr. {caseNumber}...</p>
        </div>
      </div>
    )
  }

  if (redirectTarget) {
    return <Navigate to={redirectTarget} replace />
  }

  return <Navigate to="/baade" replace />
}
